import { Box, Container, Grid, Paper, Stack, Typography } from '@mui/material';
import { FEATURES } from './constants';

const Features = () => {
	return (
		<Box component="section" sx={{ py: { xs: 7, md: 10 } }}>
			<Container maxWidth="lg">
				<Box sx={{ textAlign: 'center', mb: { xs: 5, md: 7 } }}>
					<Typography
						variant="overline"
						color="warning.main"
						sx={{ fontWeight: 700, letterSpacing: '0.14em' }}
					>
						Platform
					</Typography>
					<Typography variant="h4" component="h2" sx={{ mt: 1, fontWeight: 700 }}>
						Everything you need to bid, win, and get paid
					</Typography>
					<Typography
						variant="body1"
						color="text.secondary"
						sx={{ mt: 2, maxWidth: 640, mx: 'auto', lineHeight: 1.8 }}
					>
						Purpose-built for subcontractors who live in proposals, change
						orders, and invoice follow-ups — including the reminders so you
						don&apos;t have to send them.
					</Typography>
				</Box>

				<Grid container spacing={3}>
					{FEATURES.map((feature) => {
						const Icon = feature.icon;
						return (
							<Grid key={feature.title} size={{ xs: 12, sm: 6, md: 4 }}>
								<Paper
									elevation={0}
									sx={{
										p: 3,
										height: '100%',
										borderRadius: 3,
										border: '1px solid',
										borderColor: 'divider',
										transition: 'border-color 0.2s, box-shadow 0.2s',
										'&:hover': {
											borderColor: 'primary.main',
											boxShadow: 2,
										},
									}}
								>
									<Stack spacing={1.5}>
										<Box
											sx={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												width: 44,
												height: 44,
												borderRadius: 2,
												bgcolor: 'primary.main',
												color: 'primary.contrastText',
											}}
										>
											<Icon />
										</Box>
										<Typography
											variant="h6"
											sx={{ fontWeight: 700, fontSize: '1.05rem' }}
										>
											{feature.title}
										</Typography>
										<Typography
											variant="body2"
											color="text.secondary"
											sx={{ lineHeight: 1.7 }}
										>
											{feature.description}
										</Typography>
									</Stack>
								</Paper>
							</Grid>
						);
					})}
				</Grid>
			</Container>
		</Box>
	);
};

export default Features;
